var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "material-input",
    _vm._b(
      {
        attrs: {
          "validator-context": _vm.validatorContext,
          type: _vm.showingPassword ? "text" : "password",
          "no-auto-complete": false,
          "on-type": _vm.onType,
          placeholder: _vm.$t("account.password"),
          "client-login": _vm.clientLogin,
          "signup-client": _vm.signupClient,
          label: _vm.$t("account.password"),
          "hidden-label": "",
        },
        on: { blur: _vm.handleBlur },
        scopedSlots: _vm._u([
          {
            key: "input-icon",
            fn: function () {
              return [
                !_vm.signupClient
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons",
                        attrs: { id: "password-icon" },
                      },
                      [_vm._v("lock_outline")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.clientLogin || _vm.signupClient
                  ? _c("b-icon-eye-fill", {
                      staticClass: "clickable v-reveal-password",
                      class:
                        "" +
                        (_vm.showingPassword ? "text-primary" : "text-muted"),
                      attrs: { id: "reveal-password-controller", name: "eye" },
                      on: { click: _vm.toggleShowingPassword },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.clientLogin && !_vm.signupClient
                  ? _c("icon", {
                      staticClass: "clickable v-reveal-password",
                      class:
                        "" +
                        (_vm.showingPassword ? "text-primary" : "text-muted"),
                      attrs: { id: "reveal-password-controller", name: "eye" },
                      on: { click: _vm.toggleShowingPassword },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.passwordModel,
          callback: function ($$v) {
            _vm.passwordModel = $$v
          },
          expression: "passwordModel",
        },
      },
      "material-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }